import template from './commercial-multi-area.jade';

import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';

import validation from './../../../services/validation';

export default angular
  .module('cian.addForm.commercialMultiArea', [])
  .directive('cianAfAboutObjectCommercialMultiArea', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
      categoryInfo: '=',
    },
    controller(deviceService, $scope, store, addFormService) {
      'ngInject';

      this.isMobile = deviceService.isMobile;

      this.isVisible = () => {
        return !addFormService.getFieldValue('areaParts');
      };

      this.areaMax = 9999999;
      this.areaMin = 0;
      this.hoverIndex = -1;

      this.validation = validation(this.form, 'totalArea', {
        parse: 'Введите число',
        required: 'Укажите общую площадь',
        min: 'Площадь должна быть больше 0',
        max: 'Допустимо не более 7 символов',
      });

      this.isAreaInvalid = () => this.validation.invalid() || (this.form.minArea && this.form.minArea.$error.max);

      this.isAreaRequired = () => this.form.totalArea.$invalid;

      let trackedValue;

      this.handleBlur = () => {
        const value = this.ad.totalArea;

        if (value && value !== trackedValue) {
          const state = store.getState();
          const category = selectAnalyticsOfferStatus(state);

          trackRequiredFieldFill(category, 'total_area');
          trackedValue = value;
        }
      };

      $scope.$on('addform.clear', () => {
        this.ad.totalArea = undefined;
      });
    },
    controllerAs: 'ctrl',
    template,
  })).name;
